export function fitReportPapers(root) {
  if (!root) return;

  root.querySelectorAll('.paper').forEach((paper) => {
    const table = paper.querySelector(':scope > table');
    if (!table) return;

    table.style.zoom = '1';
    const style = window.getComputedStyle(paper);
    const padY = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    const available = paper.clientHeight - padY;
    const needed = table.getBoundingClientRect().height;

    if (available > 0 && needed > available + 2) {
      table.style.zoom = String(available / needed);
    } else {
      table.style.zoom = '';
    }
  });
}
